export function isMobile(): boolean {
  const isMobile = window.matchMedia("only screen and (max-width: 760px)")
    .matches;
  return isMobile;
}
